import React from 'react';
import { computed, makeObservable } from 'mobx';
import { observer } from 'mobx-react';

import { ComponentBase } from '../../../shared/ComponentBase.js';
import { InjectedStyledComponent } from '../../../shared/InjectedStyledComponent.js';
import { List } from '../List/List.js';
import { IListProps } from '../List/models/index.js';
import { IScaleProps } from '../Scale/models/index.js';
import { Scale } from '../Scale/Scale.js';

import { IScaleLegendConfiguration, IScaleLegendProps, IScaleLegendState } from './models/index.js';
import Wrapper from './styledComponents/Wrapper.js';
import { SCALE_LEGEND_CATEGORY_KEY, SCALE_LEGEND_COMPONENT_KEY } from './ScaleLegend.meta.js';

export class ScaleLegend extends ComponentBase<IScaleLegendProps, IScaleLegendState, IScaleLegendConfiguration> {
	categoryKey = SCALE_LEGEND_CATEGORY_KEY;
	componentKey = SCALE_LEGEND_COMPONENT_KEY;

	constructor(props: IScaleLegendProps) {
		super(props);

		makeObservable(this, {
			listProps: computed,
		});
	}

	get listProps(): IListProps {
		const { values, heading, direction = 'DESC' } = this.props;
		const max = values.length;
		const items = values.map((value, idx) => {
			const scaleProps: IScaleProps = {
				max,
				value: idx + 1,
			};
			// The List component should translate the value
			return [<Scale key={`scale_${scaleProps.value}`} {...scaleProps} />, value];
		});
		if (direction === 'DESC') {
			items.reverse();
		}
		return {
			heading,
			items,
			blankDataOptions: {
				placeholder: '',
			},
		};
	}
	render() {
		const { className } = this.props;
		return (
			<Wrapper className={className} aria-hidden={true}>
				<List {...this.listProps} />
			</Wrapper>
		);
	}
}

export default InjectedStyledComponent(observer(ScaleLegend), SCALE_LEGEND_CATEGORY_KEY, SCALE_LEGEND_COMPONENT_KEY);
